import { useNavigate } from 'react-router-dom'
import { ROUTES } from '@utils/constants.js'
import { Button } from '@components/primitives/Button.js'
import { Badge } from '@components/primitives/Badge.js'

interface Props {
  totalItens: number
  totalPassos: number
}

export function ChecklistPendentesResumoCard({ totalItens, totalPassos }: Props) {
  const navigate = useNavigate()

  if (totalItens <= 0) return null

  return (
    <article className='cf3-alerta-card cf3-alerta-card--warning cf3-checklist-resumo-card'>
      <div className='cf3-alerta-card__header'>
        <span className='cf3-alerta-card__icon' aria-hidden>
          ✓
        </span>
        <div className='cf3-alerta-card__info'>
          <span className='cf3-alerta-card__titulo'>Checklists da jornada</span>
          <Badge label='Guia' variant='warning' />
        </div>
      </div>
      <p className='cf3-alerta-card__mensagem'>
        {totalItens} {totalItens === 1 ? 'item pendente' : 'itens pendentes'} em {totalPassos}{' '}
        {totalPassos === 1 ? 'etapa' : 'etapas'} que você já avançou na jornada. Marque o que já
        verificou na sua obra.
      </p>
      <div className='cf3-alerta-card__footer cf3-checklist-resumo-card__footer'>
        <Button variant='secondary' size='sm' onClick={() => navigate(ROUTES.CHECKLIST_PENDENTES)}>
          Abrir checklists do guia
        </Button>
      </div>
    </article>
  )
}
